import { useEffect } from "react";
import Staff from '../table/Tableagent';
import Modal from "../modal/Modaladdagent"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Staff/>
    
     
     </>
  );
};

export default Dashboard;
